module.exports = __webpack_public_path__ + "static/media/mecostethus_parapleurus.f8f59385.jpg";